import { useState } from "react";
import { EmbedBookingPanel } from "./EmbedBookingPanel";
import { EmbedPricingResultsPanel } from "./EmbedPricingResultsPanel";

/**
 * Embeddable pricing calculator page
 * This page is designed to be embedded via iframe on external websites (e.g., rideminder.com/whats-coming)
 * It renders the booking input panel with a slider and an always-visible pricing results panel below
 */
export const PricingCalculator = () => {
  const [monthlyBookings, setMonthlyBookings] = useState(0);

  return (
    <div className="min-h-screen bg-transparent p-6">
      <div className="flex flex-col gap-6">
        <EmbedBookingPanel monthlyBookings={monthlyBookings} onMonthlyBookingsChange={setMonthlyBookings} />
        <EmbedPricingResultsPanel monthlyBookings={monthlyBookings} />
      </div>
    </div>
  );
};
